export var EApiDatafanProgressType;
(function (EApiDatafanProgressType) {
    EApiDatafanProgressType["PERCENT"] = "percent";
    EApiDatafanProgressType["COUNT"] = "count";
    EApiDatafanProgressType["SIMPLE_COUNT"] = "simple_count";
    EApiDatafanProgressType["TIMER"] = "timer";
    EApiDatafanProgressType["NONE_PROGRESS"] = "none_progress";
})(EApiDatafanProgressType || (EApiDatafanProgressType = {}));
//# sourceMappingURL=progress.js.map